import * as React from 'react';
import { Box, Button, Container, Divider, styled, Toolbar, Typography } from '@mui/material';
import { SocialMediaMarks } from '../../marks';
import { AppContext, Links } from '../../model';
import { AppLoader } from '../loader/app-loader';
import { FooterMenuItem } from './footer-menu-item';
import { ClassicIcon } from '../../icons';

export interface FooterProps {
  context?: AppContext;
  links?: Links;
  component?: 'div' | 'footer';
}

const FooterDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.greyBlue[400]
}));

export const Footer = (props: FooterProps) => {
  const [loading, setLoading] = React.useState(false);

  const handleMenuClick = () => {
    setTimeout(function () {
      setLoading(true);
    }, 1500);
  };

  const FooterContainer = styled(props.component ?? 'footer')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderTopColor: theme.palette.greyBlue[400],
    borderTopWidth: '1px',
    borderTopStyle: 'solid'
  }));

  return (
    <FooterContainer>
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Toolbar
          sx={{
            display: 'flex',
            flexWrap: { xs: 'wrap', md: 'nowrap', justifyContent: 'space-between' }
          }}
        >
          <Box sx={{ pt: 1, px: 1 }}>
            <ClassicIcon sx={{ fontSize: 220, height:80,  verticalAlign: 'middle' }} />
          </Box>
          <Box sx={{ pt: 1, px: 1 }}>
            <SocialMediaMarks />
          </Box>
        </Toolbar>
        {props.links && props.links.footer && (
          <Toolbar
            sx={{
              display: 'flex',
              flexWrap: 'wrap'
            }}
          >
            {props.links.footer.map((link) => (
              <FooterMenuItem key={link.id} link={link} onClick={handleMenuClick} />
            ))}
            <Typography
              component="div"
              variant="caption"
              sx={{
                p: 1,
                flexGrow: { md: 1 }
              }}
            >
              Content and images on this site may be the copyrighted property of others. All such material may not be
              copied, duplicated, or used without express written consent of each owner. Refer to Terms of Use for full
              details.
            </Typography>
          </Toolbar>
        )}
      </Container>

      <FooterDivider />

      <Container maxWidth="xl">
        <Toolbar>
          <Button color="secondary" sx={{ mr: 4 }} href="/content/privacy">
            Privacy
          </Button>
          <Button color="secondary" href="/content/terms-use-0">
            Terms of use
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          <Typography variant="caption">
            © {new Date().getFullYear()} Classic Vacations. All rights reserved.
          </Typography>
        </Toolbar>
      </Container>
      <AppLoader open={loading} />
    </FooterContainer>
  );
};
